<template lang="pug">
  app-focus-lock
    el-dialog(
      :visible="dialogVisible"
      :title="`${formTitle} User`"
      :close-on-click-modal="false"
      v-on:update:visible="closeDialog"
      top="5vh" width="100%"
    ).el-dialog__max-w-700.mx-auto.px-3.px-lg-0
      el-form(
        :model="editedItem"
        status-icon
        ref="form"
        label-position="top"
        :rules="rules"
      )
        .row
          el-form-item(label="First Name" prop="firstName").col-sm-6
            el-input(v-model="editedItem.firstName")

          el-form-item(label="Last Name" prop="lastName").col-sm-6
            el-input(v-model="editedItem.lastName")

          el-form-item(label="Email" prop="email").col-sm-6
            el-input(v-model="editedItem.email")

          el-form-item(label="Phone" prop='phone').col-sm-6
            el-input(
              v-model="editedItem.phone"
              v-mask="'(###) ###-####'" type="tel" placeholder="(123) 456-7890"
            )

          // TODO put teams back
          el-form-item(label="Team(s)").col-sm-6
            el-select(v-model="editedItem.teamsId" placeholder="Select" multiple).w-100
              el-option(
                v-for="(item) in teams" :key="item.id" :label="item.name" :value="item.id"
              )

          el-form-item(label="User Type").col-sm-6
            el-select(v-model="editedItem.userType.userType" placeholder="Select").w-100
              el-option(
                v-for="item in userTypes" :key="item.id"
                :label="item.label" :value="item.id"
              )

        template(v-if="editedItem.isVerified")
          .row
            .col-6.col-md-12.col-lg-6
              el-form-item(label="Account Status")
                el-checkbox(v-model="editedItem.isActive").mb-0 Active
            .col-6.col-md-12.col-lg-6
              el-form-item(label="Last Active")
                div {{ editedItem.lastActiveOn }}

        template(v-else)
          .row
            .col-6.col-md-12.col-lg-4
              el-form-item(label="Account Status")
                div Unverified

            template(v-if="!isNew")
              .col-6.col-md-12.col-lg-4
                el-form-item(label="Email Verification").mb-2
                  .h-40.of-h
                    el-button(
                      type="info" size="small"
                      v-loading="reSendingEmail"
                      @click="handleReSendingEmail"
                    ) Resend

              .col-12.col-lg-4
                el-form-item(label="Verification Sent")
                  .pt-12.lh-1
                    | {{ editedItem.verificationSentOn }}

      .dialog-footer(slot="footer")
        .row
          .col-auto(v-if="!isNew")
            el-button(@click="$emit('delete-item')") Delete User
          .col
            el-button(@click="closeDialog") Cancel
            el-button(type="primary" @click="validateForm('form')"  v-loading="loading")
              template(v-if="isNew") Save and Send Verification Email
              template(v-else) Update
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  name: 'DialoAaddEditUser',
  directives: { mask },

  props: {
    formTitle: { type: String, default: '' },
    editedItem: { type: Object, default: () => { } },
    dialogVisible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    userTypes: { type: Array, default: () => [] },
    teams: { type: Array, default: () => [] },
  },

  data() {
    return {
      reSendingEmail: false,
      rules: {
        email: [
          { required: true, message: 'Email address is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid Email address', trigger: 'blur' },
        ],

        phone: [
          { required: true, message: 'Phone Number is required', trigger: 'blur' },

          // Min 14 length bcoz that includes brackets and space and hyphen. eg. (###) ###-####
          { min: 14, message: 'Length should be 10 digits', trigger: 'blur' },
        ],

        firstName: {
          required: true, pattern: /^[a-zA-Z ]{2,25}$/, message: 'First Name is required', trigger: 'blur',
        },

        lastName: {
          required: true, pattern: /^[a-zA-Z ]{2,25}$/, message: 'Last Name is required', trigger: 'blur',
        },
      },
    };
  },

  computed: {
    isNew() {
      return this.formTitle === 'Add';
    },
  },

  methods: {
    submitForm() {
      console.log('Is it working.');
      this.getTeams(); // helps listing page render Team(s) data
      console.log('Is it working.');
      this.$emit('save-user-item');
    },

    getTeams() {
      console.log(this.editedItem);
      const { teamsId } = this.editedItem;
      console.log('getTeams', this.editedItem);
      this.editedItem.teams = []; // reset to push again
      if (teamsId.length) {
        teamsId.forEach((id) => {
          const teamId = this.teams.find((obj) => obj.id === id);
          delete teamId.createdAt;
          delete teamId.updatedAt;
          this.editedItem.teams.push(teamId);
        });
        console.log(this.editedItem.teams);
      }
    },

    handleReSendingEmail() {
      this.reSendingEmail = true;
      this.$emit('resend-verification');
      setTimeout(() => {
        this.reSendingEmail = false;
      }, 2000);
    },

    closeDialog() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close-dialog');
    },

    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) return this.submitForm();
        console.log('error submit!!');
        return false;
      });
    },
  },
};
</script>
